export default "__VITE_ASSET__BTTyd$eS__"